export const TREE_VIEW_NOTIFICATIONS = {
	/**
	 * mainly used on ta select, contains the new current ta id
	 * @event TREE_VIEW_NOTIFICATIONS#event:CURRENT_TA_CHANGE
	 * @type {string}
	 */
	CURRENT_TA_CHANGE: 'current-ta-change',
	UPDATE_MOBILE_STRUCTURE: 'update-mobile-structure',
	CLOSE_SVG_MOBILE_SEARCH: 'closeSvgMobileSearch',
	DRAGHOLDER_MOUSE_UP: 'dragholder-mouse-up',
	DRAGHOLDER_MOUSE_MOVE: 'dragholder-mouse-move',
	LIST_TA_UPDATED: 'list-ta-updated'
};
